import React from "react";
import axios from 'axios';
import { Switch, Route, Redirect } from "react-router-dom";

import Header from "../widgets/retail/Header";
import LeftNavbar from "../widgets/retail/LeftNavbar";
import Dashboard from "../pages/retail/Dashboard";
import Region from "../pages/retail/Region";
import Developer from "../pages/retail/Developer";
import { Page404 } from "../widgets/Page404";
import { filterDataFromUrl, Url } from '../services/utilities/util';
import { FilterProvider } from './FilterContext'

class RetailRoutes extends React.Component {

    state = {
        passedFilters: {},
        errorCode: 0
    }

    componentDidMount() {
        axios.get(process.env.REACT_APP_API_DOMAIN + process.env.REACT_APP_CHECK_RETAIL_AUTH_PATH)
            .then((response) => {
                // Success
                console.log('success');
                var filters = filterDataFromUrl(Url.get.filter);

                this.props.dispatch({
                    type: 'CHANGE_SELECTED_FILTER',
                    payload:  JSON.stringify(filters) ,
                  });
                this.setState({ errorCode: 200, passedFilters: filters });
            })
            .catch((error) => {
                // Error
                if (error.response) {
                    console.log('response error');
                    // console.log(error);
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    this.setState({ errorCode: error.response.status })
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the 
                    // browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('request error');
                    this.setState({ errorCode: 400 })
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
            });

    }

    render() {

        if (this.state.errorCode === 401) {
            return (<h6>You are not authorized to access this page</h6>)
        }

        if (this.state.errorCode === 200) {
            return (
                <FilterProvider value={{ filters: this.state.passedFilters }} >
                    <Switch>
                        <Route exact path="/retail">
                            <Redirect to='/edge/retail/dashboard' />
                        </Route>
                        <Route exact path="/retail/dashboard">
                            <div className="container-fluid ps-0 pe-0">
                                <Header />
                                <div>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-lg-1 pe-0 sideNavContainer">
                                                <LeftNavbar activeKey="1" propertyType="retail" />
                                            </div>
                                            <div className="col-lg-11 mainContainer">
                                                <Dashboard />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Route>

                        <Route exact path="/retail/region">
                            <div className="container-fluid ps-0 pe-0">
                                <Header />
                                <div>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-lg-1 pe-0 sideNavContainer">
                                                <LeftNavbar activeKey="2" propertyType="retail" />
                                            </div>
                                            <div className="col-lg-11 mainContainer">
                                                <Region />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Route>

                        <Route exact path="/retail/developer">
                            <div className="container-fluid ps-0 pe-0">
                                <Header />
                                <div>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-lg-1 pe-0 sideNavContainer">
                                                <LeftNavbar activeKey="3" propertyType="retail" />
                                            </div>
                                            <div className="col-lg-11 mainContainer">
                                                <Developer />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Route>
                        <Route path='*' exact={true} >
                            <Page404 />
                        </Route>
                    </Switch>
                </FilterProvider>
            );
        } else {
            return (<div>Loading...</div>);
        }
    }
}
export default RetailRoutes;
